export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";